module.exports = __webpack_public_path__ + "img/sdostavkoj.22c98914.png";